module.exports = __webpack_public_path__ + "img/9-tunnel_v8e.198f911c.png";